import * as React from 'react';
import { Slot } from '@radix-ui/react-slot';
import { cva, type VariantProps } from 'class-variance-authority';
import clsx from 'clsx';

const BadgeVariants = cva(
  'inline-flex items-center justify-center rounded-2xl text-sm px-2 font-medium transition-colors    disabled:pointer-events-none disabled:opacity-50',
  {
    variants: {
      variant: {
        primary: 'bg-black text-white',
        success: 'bg-success/10 text-success',
        warning: 'bg-orange-100 text-[#D19F1F] ',
        danger: 'bg-red-500/10 text-red-500',
        assent: 'bg-[#422467] text-white',
        gray: 'bg-[#F1F1F5] text-[#52526B]',
        red: 'bg-[#F60000] text-white',
        time: 'bg-[#FFE0CC] text-black',
      },
      size: {
        default: 'h-12 px-4 py-2 w-full',
        sm: 'h-9 rounded-2xl px-3 py-5 ',
        lg: 'h-11 rounded-2xl px-8',
        icon: 'h-10 w-10',
        textWithIcon: 'px-3 py-1.5 text-sm gap-1 items-center',
      },
    },
  },
);

export interface BadgeProps
  extends React.ButtonHTMLAttributes<HTMLButtonElement>, VariantProps<typeof BadgeVariants> {
  asChild?: boolean;
}

const Badge = React.forwardRef<HTMLButtonElement, BadgeProps>(
  ({ className, variant, size, asChild = false, ...props }, ref) => {
    const Comp = asChild ? Slot : 'button';
    return (
      <Comp className={clsx(BadgeVariants({ variant, size, className }))} ref={ref} {...props} />
    );
  },
);
Badge.displayName = 'Badge';

export { Badge, BadgeVariants };
